import React from 'react';

import memoizee from 'memoizee';

const nest = (...components: React.ComponentType[]): React.ComponentType => {
  if (components.length === 0) {
    throw new Error('Compose must receive at least one component');
  }

  if (components.length === 1) {
    return components[0];
  }

  const [Parent, ...descendants] = components;
  const Child = nest(...descendants);

  const Nested: React.FC = ({ children }) => {
    return (
      <Parent>
        <Child>{children}</Child>
      </Parent>
    );
  };
  return Nested;
};

// Separate memoize call because nest is recursive, and memoizing
// recursive cause infinite loop.
const memoizedNest = memoizee(nest, { length: false });

export { memoizedNest };
export default nest;
